<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon v-if="!everythingLoaded" class="load-rotate"
            >{{ formIcon }}
          </md-icon>
          <md-icon v-if="everythingLoaded">{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content v-if="everythingLoaded">
        <ValidationProvider
          name="name"
          rules="required|min:2|max:32"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Naam</label>
            <md-input v-model="name" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="description"
          rules="max:255"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Omschrijving</label>
            <md-input v-model="description" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <md-table v-model="importFields">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Volgorde"
              >{{ item.order }}
              <md-icon v-if="item.is_identifier === 1">key</md-icon>
            </md-table-cell>
            <md-table-cell md-label="Chauffeur veld">
              {{ getDriverFieldName(item) }}</md-table-cell
            >
            <md-table-cell md-label="Bestand veld">{{
              item.file_field_name
            }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>

      <md-card-actions>
        <md-button
          v-if="everythingLoaded"
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug
        </md-button>
        <md-button
          v-if="everythingLoaded"
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan
        </md-button>
      </md-card-actions>
    </md-card>

    <md-card v-if="everythingLoaded">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>add</md-icon>
        </div>
        <h4 class="title">Import veld toevoegen</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="routegroups_id"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Chauffeur veld</label>
            <md-select
              v-model="newImportField['userfield_id']"
              :name="'newField'"
              :id="'newField'"
              required
              :disabled="!everythingLoaded"
            >
              <md-option
                v-for="(driverFieldOption,
                driverFieldIndex) in getDriverFieldsForDropdown"
                :value="driverFieldOption['id']"
                :key="driverFieldIndex"
                >{{ driverFieldOption["name"] }}
              </md-option>
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="newImportField['file_field_name']"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Veldnaam in bestand</label>
            <md-input v-model="newImportField['file_field_name']" type="text">
            </md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider name="is_identifier" v-slot="{ passed, failed }">
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <md-checkbox
              v-model="newImportField['is_identifier']"
              :disabled="!everythingLoaded"
              >Identificatie veld
            </md-checkbox>

            <slide-y-down-transition></slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="addField"
          class="md-success"
          >Veld toevoegen
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      name: "",
      description: "",
      newImportField: {
        id: null,
        is_identifier: false,
        userfield_id: null,
        field_name: "",
        file_field_name: ""
      },
      importFields: [],
      driverFields: [],
      driverDefaultFields: [
        { id: "firstName", name: "Voornaam" },
        { id: "lastNamePrefix", name: "Tussenvoegsel" },
        { id: "lastName", name: "Achternaam" },
        { id: "email", name: "E-mailadres" }
      ],
      touched: {
        name: false,
        description: false,
        importFields: false
      },
      submitErrors: "",
      loaded: {
        imports: false,
        importFields: false,
        driverFields: false
      }
    };
  },
  methods: {
    init() {
      if (this.$route.params.id !== undefined) {
        this.loadImport(this.$route.params.id);
        this.loadImportFields(this.$route.params.id);
      } else {
        this.name = "";
        this.description = "";
        this.loaded.imports = true;
        this.loaded.importFields = true;

        setTimeout(this.resetTouched, 100);
      }

      this.loadDriverFields();
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            "import/templates/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            name: this.name,
            description: this.description
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Import template succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            this.setTemplateFields(response.data.importTemplate.id);
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan import template",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    setTemplateFields(templateId) {
      for (let i in this.importFields) {
        this.importFields[i].template_id = templateId;
        this.importFields[i].order = parseInt(i) + 1;
      }

      let successCounter = 0;

      for (let i in this.importFields) {
        this.$http
          .post(
            this.$apiBaseUrl +
              "import/templates/field/" +
              (this.importFields[i].id !== null ? this.importFields[i].id : ""),
            Object.assign({
              template_id: this.importFields[i].template_id,
              is_identifier: this.importFields[i].is_identifier,
              order: this.importFields[i].order,
              userfield_id: this.importFields[i].userfield_id,
              field_name: this.importFields[i].field_name,
              file_field_name: this.importFields[i].file_field_name
            })
          )
          .then(
            response => {
              successCounter++;
              setTimeout(this.resetTouched, 100);

              if (successCounter === this.importFields.length) {
                this.notifyVue(
                  "Import template velden succesvol opgeslagen",
                  "check",
                  "success",
                  5000
                );
              }
              this.setTemplateFields(response.data.importTemplate.id);
            },
            response => {
              if (response.status === 422) {
                let msg = "";

                this.submitErrors = response.data.errors;

                for (var i in response.data.errors) {
                  for (var j in response.data.errors[i]) {
                    msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                  }
                }

                this.notifyVue(msg, "add_alert", "danger", 0);
              } else {
                this.notifyVue(
                  "Onbekende fout tijdens opslaan import template",
                  "report_problem",
                  "danger",
                  0
                );
              }
            }
          );
      }

      // if (this.$route.params.id === undefined) {
      //   this.$router.go(-1);
      // }
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    addField() {
      if (
        ["firstName", "lastNamePrefix", "lastName", "email"].includes(
          this.newImportField["userfield_id"]
        )
      ) {
        this.newImportField["field_name"] = this.newImportField["userfield_id"];
        this.newImportField["userfield_id"] = null;
      }

      this.importFields.push({
        id: null,
        template_id: null,
        is_identifier: this.newImportField["is_identifier"] ? 1 : 0,
        order: this.importFields.length + 1,
        userfield_id: this.newImportField["userfield_id"],
        field_name: this.newImportField["field_name"],
        file_field_name: this.newImportField["file_field_name"]
      });

      this.newImportField["id"] = null;
      this.newImportField["is_identifier"] = 0;
      this.newImportField["userfield_id"] = null;
      this.newImportField["field_name"] = null;
      this.newImportField["file_field_name"] = "";

      this.touched.importFields = true;
    },
    getDriverFieldName(item) {
      if (item.field_name) {
        for (let i in this.driverDefaultFields) {
          if (this.driverDefaultFields[i].id === item.field_name) {
            return this.driverDefaultFields[i].name;
          }
        }
        return "";
      }

      for (let i in this.driverFields) {
        if (this.driverFields[i].id === item.userfield_id) {
          return this.driverFields[i].name;
        }
      }
      return "";
    },
    loadImport(id) {
      this.loaded.imports = false;
      this.$http.get(this.$apiBaseUrl + "import/templates/" + id).then(
        response => {
          this.name = response.data.importTemplate.name;
          this.description = response.data.importTemplate.description;

          setTimeout(this.resetTouched, 100);

          this.loaded.imports = true;
        },
        response => {
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van import templates", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadDriverFields() {
      this.loaded.driverFields = false;
      this.$http.get(this.$apiBaseUrl + "drivers/fields").then(
        response => {
          this.driverFields = response.data.fields;

          this.loaded.driverFields = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van Chauffeur velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadImportFields(id) {
      this.loaded.importFields = false;
      this.$http.get(this.$apiBaseUrl + "import/templates/fields/" + id).then(
        response => {
          this.importFields = response.data.importTemplateFields;

          this.loaded.importFields = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van Chauffeur velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    resetTouched() {
      this.touched.name = false;
      this.touched.description = false;
      this.touched.importFields = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  watch: {
    name() {
      if (this.everythingLoaded) {
        this.touched.name = true;
      }
    },
    description() {
      if (this.everythingLoaded) {
        this.touched.description = true;
      }
    }
  },
  computed: {
    title: function() {
      if (!this.everythingLoaded) {
        return "Laden";
      }
      if (this.$route.params.id !== undefined) {
        return "Import template bewerken";
      }
      return "Import template toevoegen";
    },
    formIcon: function() {
      if (!this.everythingLoaded) {
        return "hourglass_empty";
      }
      return "system_update_alt";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    getDriverFieldsForDropdown: function() {
      let fields = [];
      let usedFields = [];

      for (let i in this.importFields) {
        if (
          this.importFields[i]["userfield_id"] !== "" &&
          this.importFields[i]["userfield_id"] !== null
        ) {
          usedFields.push(this.importFields[i]["userfield_id"]);
        } else if (
          this.importFields[i]["field_name"] !== "" &&
          this.importFields[i]["field_name"] !== null
        ) {
          usedFields.push(this.importFields[i]["field_name"]);
        }
      }

      for (let i in this.driverDefaultFields) {
        if (usedFields.includes(this.driverDefaultFields[i]["id"])) {
          continue;
        }

        fields.push({
          id: this.driverDefaultFields[i]["id"],
          name: this.driverDefaultFields[i]["name"]
        });
      }

      for (let i in this.driverFields) {
        if (usedFields.includes(this.driverFields[i]["id"])) {
          continue;
        }

        fields.push({
          id: this.driverFields[i]["id"],
          name: this.driverFields[i]["name"]
        });
      }

      return fields;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;

  &:after {
    bottom: 20px;
  }
}
</style>
